import SettingsPrivacy from "../../components/header/userMenu/SettingsPrivacy";
export default SettingsPrivacy;
